<mon-panel-header
    pHeader="{{'All customers domains' | translate}}"
    subHeader="{{'This account has ' | translate}} {{ domains && domains.total }} {{ 'active domains right now' | translate}}">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
            <mon-export-all-button
                class="mr-2"
                [customer]="customer"
                (exportCompleted)="onExportCompleted()">
            </mon-export-all-button>
            
            <mon-domain-import-dropdown
                class="mr-2"
                [customer]="customer"
                [monIsBackendAdmin]="true"
                (csvImportRequested)="importDomains()"
                (jsonImportCompleted)="onImportCompleted()">
            </mon-domain-import-dropdown>
            
            <button class="btn btn-secondary mr-8"
                    type="button"
                    (click)="createDomain()"
                    [ngbTooltip]="'Add new domain' | translate"
                    [attr.aria-label]="'Add new domain' | translate"
                    data-test="add-new-domains-button">
                <mon-icon [icon]="['ACTIONS', 'ADD']"></mon-icon>
                <mon-icon [icon]="['DOMAINS', 'ICON']" [size]="'lg'"></mon-icon>
            </button>
        </div>
        
        <div>
            <mon-table-search [model]="search" [minSearchLength]="1" (getPage)="onSearchChanged($event)" data-test="search-input"></mon-table-search>
        </div>
    </div>
</mon-panel-header>
<div class="col-lg-48 inner-l-between-small-mini">
    <div class="card-body">
        <div class="col-md-48 col-lg-48 col-xs-48">
            <mon-table-container
                [collection]="domains"
                (pageChangeEvent)="onPageChange($event)"
                (perPageChange)="onPageSizeChange($event)"
                [loading]="loading"
            >
                <div class="table-container-top">
                    <div class="d-flex gap-2 align-items-center">
                        <button class="btn btn-secondary"
                                [disabled]="selectedDomains.length === 0"
                                [monConfirm]="'Are you sure you want to delete selected Domains?' | translate"
                                (monConfirmAction)="selectedDomains.length > 0 && deleteDomains()"
                                data-test="delete-selected-domains"
                                translate>
                            Delete selected domains
                        </button>
                        <button class="btn btn-secondary"
                                [disabled]="selectedDomains.length === 0"
                                [monConfirm]="'Are you sure you want to rescan selected Domains?' | translate"
                                (monConfirmAction)="selectedDomains.length > 0 && rescanDomains()"
                                data-test="rescan-selected-domains"
                                translate>
                            Rescan selected domains
                        </button>
                        <mon-export-selected-button
                            [selectedDomains]="selectedDomains"
                            [customer]="customer"
                            (exportCompleted)="onExportCompleted()">
                        </mon-export-selected-button>
                    </div>
                </div>
                <div class="table-container-body">
                    <mon-backend-admin-domains-table
                        [monDomains]="domains"
                        [monCustomer]="customer"
                        [monShowCustomer]="false"
                        [monSelectedDomains]="selectedDomains"
                        (monGetPageEvent)="getPage()"
                    ></mon-backend-admin-domains-table>
                </div>
            </mon-table-container>
        </div>

    </div>
</div>
